export const PENDENCIAS_SEEN_EVENT = 'pendencias-seen-updated';

export type ValidatorRole = 'compras' | 'contabilidade';

export interface PendenciaResumo {
  id: number;
  status: string;
}

type SeenMap = Record<string, string>;

const storageKey = (email: string, role: ValidatorRole) =>
  `pendencias_vistas_${role}_${email.toLowerCase()}`;

export function getPendenciasSeenMap(email: string, role: ValidatorRole): SeenMap {
  try {
    const raw = localStorage.getItem(storageKey(email, role));
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function markPendenciaSeen(
  email: string,
  role: ValidatorRole,
  id: number | string,
  status: string,
): void {
  const map = getPendenciasSeenMap(email, role);
  map[String(id)] = status;
  localStorage.setItem(storageKey(email, role), JSON.stringify(map));
  window.dispatchEvent(new CustomEvent(PENDENCIAS_SEEN_EVENT));
}

export function markAllPendenciasSeen(
  email: string,
  role: ValidatorRole,
  items: PendenciaResumo[],
): void {
  const map = getPendenciasSeenMap(email, role);
  items.forEach((item) => {
    map[String(item.id)] = item.status;
  });
  localStorage.setItem(storageKey(email, role), JSON.stringify(map));
  window.dispatchEvent(new CustomEvent(PENDENCIAS_SEEN_EVENT));
}

export function isPendenciaUnread(
  item: PendenciaResumo,
  email: string,
  role: ValidatorRole,
): boolean {
  const seen = getPendenciasSeenMap(email, role)[String(item.id)];
  return seen !== item.status;
}

export function countUnreadPendencias(
  items: PendenciaResumo[],
  email: string,
  role: ValidatorRole,
): number {
  return items.filter((item) => isPendenciaUnread(item, email, role)).length;
}

export function resolveValidatorRole(
  departamento: string | null | undefined,
): ValidatorRole | null {
  const dept = (departamento || '').trim().toLowerCase();
  if (dept === 'compras' || dept === 'admin') return 'compras';
  if (dept === 'contabilidade') return 'contabilidade';
  return null;
}

/** Admin, Compras ou Contabilidade — perfis com fila de validação. */
export function isValidatorDepartamento(
  departamento: string | null | undefined,
): boolean {
  return resolveValidatorRole(departamento) !== null;
}

export function getPendenciasEndpoint(role: ValidatorRole): string {
  return role === 'compras'
    ? 'http://localhost:8000/api/cadastros/pendentes'
    : 'http://localhost:8000/api/cadastros/pendentes/contabil';
}
